import { useQuery, useMutation, useQueryClient } from "react-query";
import { post, put, get } from "../../../redux/services/api";
import { hubAdminUrl_table } from "../../../utilities/constants";
// const queryClient = useQueryClient()

interface payload {
  PageSize: number;
  PageNumber: number;
  search:string;
  Status?: number;
}
const fetchAdminList = async (payload: payload) => {
  const { PageNumber, PageSize,search,Status=0 } = payload;
  const { data } = await get(
    // `${hubAdminUrl_table}/v1/Complain?PageSize=${PageSize}&PageNumber=${PageNumber}&LocationId=${locationId}`
    `${hubAdminUrl_table}api/v1/user/get-hub-users-list?PageNumber=${PageNumber}&PageSize=${PageSize}&SearchString=${search}&Flag=${1}&Status=${Status}`
  );
  return data;
};

export const useAdmin = (payload: payload) => {
    const { PageNumber, PageSize ,search,Status} = payload;
  return useQuery({
    queryKey: ["fetchAdminList", PageNumber,PageSize,search,Status],
    queryFn: () => fetchAdminList(payload),
    refetchOnWindowFocus: false,
  });
};

// export default useComplain
